var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_2065)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4485 15.3183C21.0468 16.4033 22.1668 17.8733 22.1668 19.8333V23.3333H25.6668C26.3085 23.3333 26.8335 22.8083 26.8335 22.1667V19.8333C26.8335 17.29 22.6685 15.785 19.4485 15.3183Z",
    fill: "#233EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 14C13.0772 14 15.1666 11.9107 15.1666 9.33332C15.1666 6.75599 13.0772 4.66666 10.4999 4.66666C7.92259 4.66666 5.83325 6.75599 5.83325 9.33332C5.83325 11.9107 7.92259 14 10.4999 14Z",
    fill: "#233EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4999 14C20.0782 14 22.1666 11.9117 22.1666 9.33332C22.1666 6.75499 20.0782 4.66666 17.4999 4.66666C16.9516 4.66666 16.4382 4.78332 15.9482 4.94666C16.9166 6.14832 17.4999 7.67666 17.4999 9.33332C17.4999 10.99 16.9166 12.5183 15.9482 13.72C16.4382 13.8833 16.9516 14 17.4999 14Z",
    fill: "#233EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4998 15.1667C7.38484 15.1667 1.1665 16.73 1.1665 19.8333V22.1667C1.1665 22.8083 1.6915 23.3333 2.33317 23.3333H18.6665C19.3082 23.3333 19.8332 22.8083 19.8332 22.1667V19.8333C19.8332 16.73 13.6148 15.1667 10.4998 15.1667Z",
    fill: "#233EFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_2065"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.52ac3518fc32571b04de284d78bd1b60.svg";
export { ForwardRef as ReactComponent };